const OTP_GENERATE = "otpGenerate";
const OTP_VALIDATE = "otpValidate";
const OTP_VALIDATE_REFERAL = "otpValidate";

const DECISION = "decision";
const COMPANIES = "companies";
const SEND_FORM_DATA = "sendFormData";
const SEND_BANK_STATEMENT = "sendBankStatement";
const INSTITUTIONS = "institutions";
// status
//added by ATTRA for the enhancement on 10-OCT-2019 Start
const GET_CIF = "cif";
const CIF_UPDATE = "cifUpdate";
const LEAD_CREATION = "leadCreation";
const INCOME_UPDATE = "incomeUpdate";
const CREDIT_SCORE_CALCULATION = "scoreCalculation";
const CREDIT_REPORT = "creditReport";
const SR_CREATE = "srCreate";
const LEAD_SQUARDED = "leadSquarded";
const WORK_EMAIL_VALIDATE = "workEmailValidate";
const PERSONAL_EMAIL_VALIDATE = "personalEmailValidate";
const PROMO_CODE = "promoCode";
const BRANCH_DETAILS = "branchDetails";
const APPIAN_PERSONAL_INFO = "appianPersonalInfo";
const APPIAN_IDENTITY_INFO = "appianIdentityInfo";
const APPIAN_EMP_INFO = "appianEmpInfo";
const APPIAN_INCOME_INFO = "appianIncomeInfo";
const CREATE_ADDRESS = "createAddress";
const ACCUITY = "accuity";
const CREDIT_CC_SCORE = "creditCCScore";
const CREATE_INSURANCE = "CREATE_INSURANCE";
const CUSTOMER_EXIST = "CUSTOMER_EXIST";
const CRM_CONTACT_VALIDATE = "crmContactValidate";
const ACCUITY_SUPPLEMENTARY = "accuitySupplementary";
const AUTOMATION_API = "automationAPI";
const AUTO_LOAN_DETAILS = "autoLoanDetails";
//end by ATTRA
const CREDIT_SCORE = "creditScore";
const MONTHLY_INSTALMENT = "monthlyInstalment";
const START_TRANSACTION = "startTransaction";
const END_TRANSACTION = "endTransaction";
const SALARY_VERIFICATION = "salaryVerification";
const IDENTITY_VERIFICATION = "identityVerification";
const REFERAL_DATA = "referralData";
const BANK_NAMES = "bankName";
const CRM_VALIDATION = "crmValidation";
const EMAILNOTIFICATION = "emailNotification";
const MERCHANTNOTIFICATION = "merchantNotification";
const SERVICE_STATUS = {
  success: "SUCCESS",
  unvalidated: "UNVALIDATED",
  fail: "FAIL"
};
const SERVICE_STATUS_REFRAL = {
  success: "SUCCESS",
  unvalidated: "UNVALIDATED",
  fail: "FAIL"
};

export {
  OTP_GENERATE,
  OTP_VALIDATE,
  SERVICE_STATUS,
  DECISION,
  COMPANIES,
  SEND_FORM_DATA,
  INSTITUTIONS,
  WORK_EMAIL_VALIDATE,
  PERSONAL_EMAIL_VALIDATE,
  //added by ATTRA for the enhancement on 10-OCT-2019 Start
  GET_CIF,
  CIF_UPDATE,
  ACCUITY_SUPPLEMENTARY,
  //end by ATTRA
  CREDIT_SCORE,
  MONTHLY_INSTALMENT,
  START_TRANSACTION,
  END_TRANSACTION,
  SALARY_VERIFICATION,
  SEND_BANK_STATEMENT,
  IDENTITY_VERIFICATION,
  LEAD_CREATION,
  INCOME_UPDATE,
  CREDIT_SCORE_CALCULATION,
  CREDIT_REPORT,
  SR_CREATE,
  LEAD_SQUARDED,
  PROMO_CODE,
  BRANCH_DETAILS,
  APPIAN_PERSONAL_INFO,
  APPIAN_IDENTITY_INFO,
  APPIAN_EMP_INFO,
  APPIAN_INCOME_INFO,
  SERVICE_STATUS_REFRAL,
  OTP_VALIDATE_REFERAL,
  CREATE_ADDRESS,
  ACCUITY,
  CREDIT_CC_SCORE,
  CREATE_INSURANCE,
  CUSTOMER_EXIST,
  REFERAL_DATA,
  CRM_CONTACT_VALIDATE,
  BANK_NAMES,
  CRM_VALIDATION,
  EMAILNOTIFICATION,
  MERCHANTNOTIFICATION,
  AUTOMATION_API,
  AUTO_LOAN_DETAILS
};
